"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaObject = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var config_context_1 = require("../_util/config-context");
exports.MediaObject = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? 'top' : _c, reverse = _a.reverse, media = _a.media, children = _a.children, className = _a.className, props = (0, tslib_1.__rest)(_a, ["align", "reverse", "media", "children", "className"]);
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    return (react_1.default.createElement("div", (0, tslib_1.__assign)({ ref: ref, className: (0, classnames_1.default)(className, classPrefix + "-media", (_b = {},
            _b[classPrefix + "-media--reverse"] = reverse,
            _b[classPrefix + "-media--middle"] = align === 'middle',
            _b[classPrefix + "-media--bottom"] = align === 'bottom',
            _b)) }, props),
        media && react_1.default.createElement("div", { className: classPrefix + "-media__left" }, media),
        react_1.default.createElement("div", { className: classPrefix + "-media__body" }, children)));
});
exports.MediaObject.displayName = 'MediaObject';
